import Utils from "../utils/utils"
import LogHelper from "../utils/logHelper"
const utilsHelper = new Utils()

export default class DetectInstallSDK{
    constructor(container_id, config, is_debug) {
        this.container_id = container_id
        this.config = config
        this.is_debug = is_debug
        this.logHelper = new LogHelper(config.LOG_LEVEL, config.LOG_ENDPOINT, is_debug, container_id)
    }

    async run(current_url) {
        console.log('optimize99_run:', 'DetectInstallSDK')
        console.log('current_url', current_url)
        let url = new URL(current_url)
        
        let is_checkInstall = url.searchParams.get('checkInstall')
        console.log('checkInstall', is_checkInstall)

        if (is_checkInstall !== 'true') {
            return
        }
    
        let url_container_id = url.searchParams.get('container_id')
        if (url_container_id !== this.container_id) {
            return
        }
        console.log('detect_install:', url_container_id)
        
        let url_token = url.searchParams.get('token')

    
        // 打確認安裝token的API
        try {
            let platform = utilsHelper.checkPlatform()
            let shop_id = ''
            if (platform === 'shopline') {
                shop_id = utilsHelper.getShoplineMerchantId()
            }
            else if (platform === '91app') {
                shop_id = utilsHelper.get91appMerchantId()
            }
            let params = JSON.stringify({
                shop_id: shop_id,
                platform: platform
            })
            params = encodeURIComponent(params)
            let result = await utilsHelper.callAPI(
                '', 
                'GET', 
                this.config.API_ENDPOINT + `/view/container/check?id=${url_container_id}&token=${url_token}&platform=${params}`, 
                null
            )
            if (result.ok !== 1) {
                let message = ''
                if (result.msg === 'bad token') {
                    message = '檢查安裝失敗，請重新到Optimize99檢查安裝狀態，原因: token過期'
                }
                alert(message)
            }
            else {
                alert('代碼安裝成功！')
            }
        } catch (error) {
            console.log('error:', error)
        }

    }
}